{
  "level": "citymov",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:citymov",
    "objects": "AREAS.E3:citymov.e3",
    "mesh": "TREES.E3:citymov.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        -500.0,
        -100.0,
        -1300.0
      ],
      "bbox_max": [
        -200.0,
        0.0,
        -1300.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: celedor1",
      "entity_class": "CSlidingDoor",
      "piece_name": "celedor1",
      "offset": 2072,
      "centroid": [
        -297.5,
        531.5,
        90.0
      ],
      "bbox_min": [
        -305.0,
        530.0,
        80.0
      ],
      "bbox_max": [
        -290.0,
        533.0,
        100.0
      ],
      "dimensions_source": {
        "span_x": 15.0,
        "span_y": 3.0,
        "height_z": 20.0,
        "door_width": 15.0,
        "door_depth": 3.0,
        "leaf_depth": 2.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -290.0,
          530.0,
          100.0
        ],
        [
          -305.0,
          530.0,
          100.0
        ],
        [
          -305.0,
          530.0,
          80.0
        ],
        [
          -290.0,
          530.0,
          80.0
        ],
        [
          -305.0,
          533.0,
          80.0
        ],
        [
          -290.0,
          533.0,
          80.0
        ],
        [
          -305.0,
          533.0,
          100.0
        ],
        [
          -290.0,
          533.0,
          100.0
        ]
      ],
      "plane_distance": 530.0,
      "authentic_texture": "spkelevdoor1"
    },
    {
      "tag": "CSlidingDoor piece: celedor2",
      "entity_class": "CSlidingDoor",
      "piece_name": "celedor2",
      "offset": 4333,
      "centroid": [
        -297.5,
        535.75,
        155.0
      ],
      "bbox_min": [
        -305.0,
        535.0,
        145.0
      ],
      "bbox_max": [
        -290.0,
        536.5,
        165.0
      ],
      "dimensions_source": {
        "span_x": 15.0,
        "span_y": 1.5,
        "height_z": 20.0,
        "door_width": 15.0,
        "door_depth": 1.5,
        "leaf_depth": 1.46,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -305.0,
          535.0,
          145.0
        ],
        [
          -290.0,
          535.0,
          145.0
        ],
        [
          -290.0,
          535.0,
          165.0
        ],
        [
          -305.0,
          535.0,
          165.0
        ],
        [
          -290.0,
          536.5,
          165.0
        ],
        [
          -290.0,
          536.5,
          145.0
        ],
        [
          -305.0,
          536.5,
          145.0
        ],
        [
          -305.0,
          536.5,
          165.0
        ]
      ],
      "plane_distance": 535.0,
      "authentic_texture": "spkelevdoor1"
    },
    {
      "tag": "CSlidingDoor piece: puzzdr",
      "entity_class": "CSlidingDoor",
      "piece_name": "puzzdr",
      "offset": 6515,
      "centroid": [
        439.5,
        990.0,
        127.5
      ],
      "bbox_min": [
        439.0,
        985.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        995.0,
        135.0
      ],
      "dimensions_source": {
        "span_x": 1.0,
        "span_y": 10.0,
        "height_z": 15.0,
        "door_width": 10.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          0.0,
          0.0,
          1.0
        ]
      },
      "vertices": [
        [
          440.0,
          995.0,
          135.0
        ],
        [
          440.0,
          995.0,
          120.0
        ],
        [
          440.0,
          985.0,
          120.0
        ],
        [
          440.0,
          985.0,
          135.0
        ],
        [
          439.0,
          995.0,
          135.0
        ],
        [
          439.0,
          985.0,
          135.0
        ],
        [
          439.0,
          985.0,
          120.0
        ],
        [
          439.0,
          995.0,
          120.0
        ]
      ],
      "plane_distance": -135.0,
      "authentic_texture": "slidedoor1"
    }
  ],
  "tutorial_messages": []
}